<template>
  <CRUDCriteria
    :showSearch="false"
    :showReset="true"
    :resetCriteria="resetCriteria"
  >
    <template v-slot:criteriaRows>
      <v-row dense>
        <v-col cols="6">
          <v-autocomplete
            id="bankSelect"
            label="Bank"
            v-model="criteriaState.bankId"
            :items="bankList"
            item-text="bankName"
            item-value="_id"
            clearable
            @change="handleBankChange"
            autocomplete="off"
          />
        </v-col>
      </v-row>
    </template>
  </CRUDCriteria>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapMutations,
} from 'vuex';
import CRUDCriteria from '../../common/base/crud/CRUDCriteria.vue';

const bankListCrudKey = 'treasurersChecksBankList';

export default {
  name: 'TreasurersChecksCriteria',
  components: {
    CRUDCriteria,
  },
  props: {
    baseCrudKey: {
      type: String,
      required: true,
    },
  },
  async created() {
    await this.loadBanks({ criteria: {}, baseCrudKey: bankListCrudKey });
  },
  computed: {
    ...mapGetters('base/crud', ['criteria', 'items']),
    bankList() {
      return this.items(bankListCrudKey) || [];
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey) || {};
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setCriteria']),
    ...mapActions('shared/bank', ['loadBanks']),
    handleBankChange() {
      this.$emit('loadCRUDList');
    },
    resetCriteria() {
      this.criteriaState = {};
      this.$emit('loadCRUDList');
    },
  },
};
</script>
